/**
 * Authentication-related constants
 */

// Result codes that indicate password change is required
export const RESULT_CODE_PASSWORD_CHANGE_REQUIRED = -8000; // Generic
export const RESULT_CODE_PASSWORD_EXPIRED = -8001;
export const RESULT_CODE_PASSWORD_TEMPORARY = -8002;
export const RESULT_CODE_PASSWORD_ADMIN_FORCED_CHANGE = -8003;

// Password validation error codes
export const RESULT_CODE_PASSWORD_NOT_COMPLIANT = -8011;
export const RESULT_CODE_PASSWORD_REUSED = -8012;

// Array of all password change result codes
export const PASSWORD_CHANGE_RESULT_CODES = [
  RESULT_CODE_PASSWORD_CHANGE_REQUIRED,
  RESULT_CODE_PASSWORD_EXPIRED,
  RESULT_CODE_PASSWORD_TEMPORARY,
  RESULT_CODE_PASSWORD_ADMIN_FORCED_CHANGE,
];

// Array of password validation error codes
export const PASSWORD_VALIDATION_ERROR_CODES = [
  RESULT_CODE_PASSWORD_NOT_COMPLIANT,
  RESULT_CODE_PASSWORD_REUSED,
];
